import React from 'react';
import Input from 'components/Form/Input';
import { useTranslation } from 'react-i18next';


const RoomLabel = () => {
  const { t } = useTranslation();

  return (
    <>
      <Input name="roomId" label={t('Room ID')} placeholder={t('Type optional room ID...')} maxLength={8} size="sm" />
      <Input name="gameSettings.label" label={t('Room label')} placeholder={t('Type optional room description...')} maxLength={32} size="sm" />
    </>
  );
};

export default RoomLabel;
